export default __webpack_public_path__ + "static/media/7.b0c72da2.png";